import { relatoriolaudoestadoconservacaoibp } from "@/reports/pdf/patrimonio/itembempermanente/relatoriolaudoestadoconservacaoibp/index.js";


export function geradorDePdf(type, estadoConservacao,  title) {
  switch (type) {
      case "rlaecIBP":
        relatoriolaudoestadoconservacaoibp(estadoConservacao, title);
        break;
  }
  
}
